import { render } from "./dental_list.vue?vue&type=template&id=4d4aa9ce&scoped=true"
import script from "./dental_list.vue?vue&type=script&lang=js"
export * from "./dental_list.vue?vue&type=script&lang=js"

import "./dental_list.vue?vue&type=style&index=0&id=4d4aa9ce&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4aa9ce"]])

export default __exports__